import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { apps } from '../data/apps';

const billedApps = apps.filter((app) => app.webBilling);

// 网页订阅的总退款政策：和 DracoChinese、DracoLanguage 各自的退款政策一致（14 天无理由退款）
const Refund: React.FC = () => {
  return (
    <LegalLayout title="Refund Policy" lastUpdated="October 24, 2026">
      <p>
        Premium subscriptions on the websites of our apps are sold by Paddle.com, our reseller and Merchant of
        Record. Refunds are therefore issued by Paddle, to the payment method you used.
      </p>

      <h2>14-day money-back guarantee</h2>
      <p>
        If Premium is not right for you, you can ask for a full refund within 14 days of any payment, whether it is
        your first payment or a renewal. You do not need to give a reason. When the refund is issued, the
        subscription ends.
      </p>

      <h2>After 14 days</h2>
      <p>
        After 14 days, payments are generally not refunded. You can still cancel at any time, and Premium stays
        active until the end of the period you have paid for. If something went wrong, for example you were charged
        twice or Premium did not work for you because of a problem on our side, please contact us and we will find
        a solution.
      </p>

      <h2>How to ask for a refund</h2>
      <ul>
        <li>
          Use the link in the receipt email from Paddle, or go to{' '}
          <a href="https://paddle.net" target="_blank" rel="noopener noreferrer">paddle.net</a> and look up your
          order, or
        </li>
        <li>
          write to <a href="mailto:service@spiegeleistudio.com">service@spiegeleistudio.com</a> with the email
          address you used for the purchase.
        </li>
      </ul>
      <p>Refunds usually reach your account within 5 to 10 business days, depending on your bank.</p>

      <h2>Purchases in the iOS or Android app</h2>
      <p>
        Subscriptions bought inside the iOS or Android apps are billed by Apple or Google. Refunds for these
        purchases are handled by Apple or Google under their own policies.
      </p>

      <h2>Refund policies of each app</h2>
      <ul>
        {billedApps.map((app) => (
          <li key={app.id}>
            {app.title}: <a href={app.webBilling!.refundUrl}>Refund Policy</a>
          </li>
        ))}
      </ul>

      <h2>Your statutory rights</h2>
      <p>This policy does not limit any rights you have under the consumer protection laws of your country.</p>
    </LegalLayout>
  );
};

export default Refund;
